import { ReactElement } from 'react';
import { CardNumber } from '../components/Fields/CardNumber';
import { ExpirationDate } from '../components/Fields/ExpirationDate';
import { Cvv } from '../components/Fields/Cvv';
import { AccountNumber } from '../components/Fields/AccountNumber';
import { Routing } from '../components/Fields/Routing';
import { FeeComponentProps, FieldComponentProps, ValidFieldTypes } from '../types';
import { FeeInfo } from '../components/FeeInfo';
import { ApplePay } from '../components/Fields/ApplePay';
import { GooglePay } from '../components/Fields/GooglePay';
import { TuaPay } from '../components/Fields/TuaPay';
import { TuaPayFrameContainer } from '../components/Fields/TuaPay/TuaPayFrameContainer';

const viewFormMapData: ([
  string, 
  (params: FieldComponentProps & FeeComponentProps) => ReactElement,
])[] = [
  [ValidFieldTypes.CARD_NUMBER,
    (params: FieldComponentProps) => <CardNumber {...params} />],
  [ValidFieldTypes.EXPIRATION_DATE,
    (params: FieldComponentProps) => <ExpirationDate {...params} />],
  [ValidFieldTypes.CVV,
    (params: FieldComponentProps) => <Cvv {...params} />],
  [ValidFieldTypes.ACCOUNT_NUMBER,
    (params: FieldComponentProps) => <AccountNumber {...params} />],
  [ValidFieldTypes.ROUTING,
    (params: FieldComponentProps) => <Routing {...params} />],
  [ValidFieldTypes.APPLE_PAY,
    (params: FieldComponentProps) => <ApplePay {...params} />],
  [ValidFieldTypes.GOOGLE_PAY,
    (params: FieldComponentProps) => <GooglePay {...params} />],
  [ValidFieldTypes.TUAPAY,
    (params: FieldComponentProps) => <TuaPay {...params} />],
  [ValidFieldTypes.TUAPAY_FRAME_CONTAINER,
    (params: FieldComponentProps) => <TuaPayFrameContainer {...params} />],

  // fee
  [ValidFieldTypes.CARD_FEE,
    (params: FeeComponentProps) => <FeeInfo {...params} />],
  [ValidFieldTypes.ACH_FEE,
    (params: FeeComponentProps) => <FeeInfo {...params} />],
];

const view: Map<string, (params: FieldComponentProps & FeeComponentProps) =>
  ReactElement> = new Map(viewFormMapData);

export const getViewFormComponent = (fieldType: string, params: FieldComponentProps & FeeComponentProps) => {
  const formData = view.get(fieldType);
  return formData ? formData(params) : <></>;
};
